(() => {
  if (window.sealKlaviyoPopupAccessibilityInitialized) return;
  window.sealKlaviyoPopupAccessibilityInitialized = true;

  const isVisible = (element) => {
    const styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const getOpenKlaviyoDialog = () => Array.from(
    document.querySelectorAll('[role="dialog"][aria-modal="true"]')
  ).find((dialog) => {
    if (!isVisible(dialog)) return false;

    return dialog.matches('[class*="kl-private-reset-css"], [data-testid*="klaviyo" i]')
      || dialog.querySelector('[class*="kl-private-reset-css"], [class*="klaviyo" i], [data-testid*="klaviyo" i], form[class*="klaviyo" i]');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;

    const dialog = getOpenKlaviyoDialog();
    if (!dialog) return;

    const closeButton = dialog.querySelector(
      'button[aria-label*="close" i], [role="button"][aria-label*="close" i], button[data-testid*="close" i]'
    );

    if (!closeButton) return;

    event.preventDefault();
    closeButton.click();
  });
})();
